/**
 * AB测类型
 */
export enum AbTestEnum {
  /** A测 */
  ATest = 'aTest',
  /** B测 */
  BTest = 'bTest',
  /** C测 */
  CTest = 'cTest',
}